import { t } from '@/i18n/utils'

/**
 * Collection 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  get noMore() { return `${t('NoMore')} ~` },
  get loading() { return `${t('Loading')}...` },
} as const
